import PropTypes from "prop-types";
import React, { Component } from "react";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";

class FileChip extends Component {
    constructor(props) {
        super(props);
        this.onFileChipClick = this.onFileChipClick.bind(this);
    }
    
    onFileChipClick(uri) {
        let result = uri;
        if (uri.includes("mueller")) {
            let combiner = uri.includes("?") ? "&" : "?";
            result = uri + combiner + "SSO=" + this.props.token;
        }

        window.open(encodeURI(result, "_blank"));
    }

    render() {
        return (
            <Chip
                onClick={e => this.onFileChipClick(this.props.uri, e)}
                sandbox="allow-same-origin allow-scripts"
                avatar={
                    <Avatar>
                        <Icon>insert_drive_file</Icon>
                    </Avatar>
                }
                label={<strong>{this.props.displayName}</strong>}
            />
        );
    }
}

FileChip.propTypes = {
    displayName: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
};

export default FileChip;
